module.exports = __webpack_public_path__ + "img/pin.09204f6a.svg";